import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { PageSEO } from "@/components/PageSEO";
import { API } from "@/lib/constants";
import { sendAdsConversion, ADS_LABELS, isTestLead } from "@/lib/adsConversions";

/* Pagina di conferma dopo il pagamento: conferma l'incasso del canone e dà il link personale della scheda. */

const QmdpAttivataPage = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [stato, setStato] = useState("verifica");
  const [dati, setDati] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStato("errore"); return; }
    let tentativi = 0;
    const chiedi = async () => {
      try {
        const { data } = await axios.get(`${API}/qmdp/attivazione/${sessionId}`);
        if (data.pagato) {
          setDati(data);
          setStato("ok");
          if (!data.prova && !isTestLead(data.nome, data.email)
              && !localStorage.getItem(`qmdp_conv_${sessionId}`)) {
            localStorage.setItem(`qmdp_conv_${sessionId}`, "1");
            sendAdsConversion(ADS_LABELS.acquistoProdotto, {
              value: 8.11, transaction_id: sessionId,
            });
          }
          return;
        }
      } catch (e) { /* riprova */ }
      if (++tentativi < 10) setTimeout(chiedi, 2000);
      else setStato("errore");
    };
    chiedi();
  }, [sessionId]);

  return (
    <main className="pt-32 pb-24 min-h-screen bg-[#FAF8F5]" data-testid="qmdp-attivata-page">
      <PageSEO title="Abbonamento attivo | Quanto Mettere da Parte" description="Conferma di attivazione." noindex />
      <div className="max-w-2xl mx-auto px-6">
        {stato === "verifica" && <p className="text-[#64708A]" data-testid="qmdp-attivata-verifica">Stiamo confermando il pagamento…</p>}
        {stato === "errore" && (
          <div data-testid="qmdp-attivata-errore">
            <h1 className="font-heading text-4xl text-[#0D1527]">NON RIUSCIAMO A CONFERMARE IL PAGAMENTO</h1>
            <p className="text-[#4A5568] mt-4">
              Se l'addebito è andato a buon fine ti arriva comunque la mail di benvenuto. Scrivici a{" "}
              <a className="text-[#8A6A28] underline" href="mailto:assistenza@casalisilvia.com">assistenza@casalisilvia.com</a>.
            </p>
          </div>
        )}
        {stato === "ok" && dati && (
          <div data-testid="qmdp-attivata-ok">
            <p className="text-[#2F7DBF] text-xs tracking-[0.3em] mb-4">ABBONAMENTO ATTIVO</p>
            <h1 className="font-heading text-4xl sm:text-5xl text-[#0D1527] leading-tight">
              CI SIAMO{dati.nome ? `, ${dati.nome.split(" ")[0].toUpperCase()}` : ""}
            </h1>
            <p className="text-[#4A5568] mt-5">
              Il canone di 9,90 € è stato addebitato e ti abbiamo mandato la mail di benvenuto con le condizioni,
              il modulo di recesso e il tuo link personale.
            </p>
            <p className="text-[#4A5568] mt-3">
              Ora serve solo una cosa: la scheda con i dati della tua attività. Cinque minuti, una volta sola.
            </p>
            <Link to={dati.link_scheda} data-testid="qmdp-attivata-scheda"
              className="inline-block mt-8 px-8 py-3.5 rounded bg-[#2F7DBF] text-white font-bold tracking-wide hover:bg-[#1F4E75] transition-colors">
              COMPILA LA SCHEDA
            </Link>
            <p className="text-[#8E9AAE] text-xs mt-6">
              Il primo giorno del mese ti arriva la domanda sull'incasso. Puoi disdire quando vuoi dal link
              «Disdici l'abbonamento» presente in ogni email.
            </p>
          </div>
        )}
      </div>
    </main>
  );
};

export default QmdpAttivataPage;
